/**
 * ComplianceDisclaimer
 *
 * Reusable notice for all pages/components that display compliance-related data.
 * Use this wherever document status, checklists, or regulatory tracking is shown.
 */
export function ComplianceDisclaimer({ className = '' }) {
  return (
    <p className={`text-xs text-muted-foreground border border-border rounded-md px-3 py-2 bg-muted/40 ${className}`}>
      This is a tracking tool only. Always verify your obligations with a
      qualified legal professional or{' '}
      <span className="font-medium">gov.uk</span> guidance.
    </p>
  );
}
